import { NavLink } from 'react-router-dom';

import type { JSX } from 'react';

/**
 * 404画面
 */
export default function Error404(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <main>
        <section className="section-404 vh-100">
          <div className="container">
            <div className="align-middle d-flex flex-column justify-content-center align-items-center">
              <img
                src="/img/common/logo.svg"
                alt="BranQ ブランク"
                className="d-block mx-auto card-logo"
              />
              <h3>404 NOT FOUND</h3>
              <p className="text-center">お探しのページが見つかりません。</p>
              <NavLink to={'/'} className="btn btn-common d-inline-block moderate-blue">
                HOMEに戻る
              </NavLink>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
